import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo-container">
      <svg
        viewBox="0 0 300 120"
        xmlns="http://www.w3.org/2000/svg"
        className="logo-svg"
      >
        <defs>
          {/* Gradient for the number 5 - magenta to cyan */}
          <linearGradient id="gradient5" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ff00ff" stopOpacity="1" />
            <stop offset="50%" stopColor="#ff00cc" stopOpacity="1" />
            <stop offset="100%" stopColor="#00ffff" stopOpacity="1" />
          </linearGradient>
          
          {/* Glow filter for the 5 */}
          <filter id="glow">
            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
          
          {/* Shadow filter for BG text */}
          <filter id="shadow">
            <feDropShadow dx="2" dy="2" stdDeviation="2" floodColor="#000000" floodOpacity="0.35"/>
          </filter>
        </defs>
        
        {/* BG Text - white with shadow */}
        <text
          x="30"
          y="75"
          fontSize="72"
          fontWeight="bold"
          fill="var(--logo-bg-fill)"
          fontFamily="Arial, sans-serif"
          className="logo-bg"
          filter="url(#shadow)"
        >
          BG
        </text>
        
        {/* Number 5 with gradient and glow */}
        <text
          x="150"
          y="75"
          fontSize="72"
          fontWeight="bold"
          fill="url(#gradient5)"
          fontFamily="Arial, sans-serif"
          className="logo-5"
          filter="url(#glow)"
        >
          5
        </text>
        
        {/* Curved tail extending from the 5 */}
        <path
          d="M 165 80 Q 140 95 100 90 Q 60 85 30 80"
          stroke="url(#gradient5)"
          strokeWidth="5"
          fill="none"
          className="logo-tail"
          filter="url(#glow)"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default Logo;

